import axios from "axios";
import { api } from "./helper";
import store from "../../store/store"
import { v4 as uuidv4 } from "uuid";

function prepareRequest(data) {
  return { ...data, RequestCorrelationId: uuidv4() };
}

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function GetCalendarJournal(item) {
  return client.post("Journals/GetCalendarJournal", prepareRequest(item));
}

function GetDebtJournal(item) {
  if (!item.searchText || item.searchText.trim() === "") {
    item.searchText = null;
  }
  return client.post("Journals/GetDebtJournal", prepareRequest(item));
}

function GetWarningJournal(item) {
  if (!item.searchText || item.searchText.trim() === "") {
    item.searchText = null;
  }
  return client.post("Journals/GetWarningJournal", prepareRequest(item));
}

export {
  GetCalendarJournal,
  GetDebtJournal,
  GetWarningJournal
}
